import React, { useEffect, useMemo, useState } from "react";
import { List } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";

import IconText from "./icon-text";

const Draft = ({ isNewPage }) => {
	const savedForm = useMemo(
		() => JSON.parse(sessionStorage.getItem("new-voting")) || {},
		[isNewPage]
	);
	const [title, setTitle] = useState("Новый опрос");
	const [period, setPeriod] = useState("");
	useEffect(() => {
		savedForm.title && setTitle(savedForm.title);
		savedForm.period && setPeriod(savedForm.period);
	}, [savedForm]);
	if (!savedForm) return null;
	const dt = savedForm.timestamp
		? moment(savedForm.timestamp).format("DD.MM.YY HH:mm")
		: moment().format("DD.MM.YY HH:mm");

	const dtb = period && moment(period[0]).format("DD.MM.YY");
	const dte = period && moment(period[1]).format("DD.MM.YY");

	return (
		<Link to="/Voting/new">
			<List.Item
				key={"draft-list-item"}
				className={`list-item draft ${isNewPage ? "list-item-active" : ""}`}
			>
				<List.Item.Meta
					title={
						<div className="header">
							<span className="title">{title}</span>
							<span className="status">Черновик</span>
						</div>
					}
				/>
				<div className="period">
					{dtb && dte && (
						<>
							{dtb} - {dte}
						</>
					)}
				</div>
				<div className="additional-info">
					<IconText tip="ID опроса" key="list-vertical-star-o" />
					<IconText
						type="calendar-o"
						tip="Время изменения"
						text={dt}
						key="list-vertical-like-o"
					/>
				</div>
			</List.Item>
		</Link>
	);
};

export default Draft;
